















import {Component, Vue} from 'vue-property-decorator';
import { Zone } from '@/model/Zone';
import { StoreService } from '@/services/StoreService';
import AlertDashBoard from '@/components/alert/AlertDashboard.vue';
import {Inject} from "vue-typedi";

@Component({
    components: {AlertDashBoard}
})
export default class AlertBody extends Vue {

    @Inject()
    storeService!: StoreService;

    allZones: Zone[] = [];

    created() {
        this.storeService.getStoreById().then(store => {
            this.filterAndSortZones(store.zones);
        });
    }

    private filterAndSortZones(zones: Zone[]) {
        this.allZones = zones
                .filter(zone => zone.enabled)
                .sort((a, b) => a.zoneLabel > b.zoneLabel ? 1 : -1);
    }

}
